import { DEVICE_FEE_CATEGORY_ID } from '@/pages/product/consts';
import { useProducts } from '../api/hooks/product';

export const useDeviceFees = (effectiveDate?: Date) => {
  const [products] = useProducts(effectiveDate);

  const deviceFeeProducts = products.filter(p => p.category.id === DEVICE_FEE_CATEGORY_ID);

  return deviceFeeProducts;
};
